import { render, staticRenderFns } from "./AddPatent.vue?vue&type=template&id=8604dc6e"
import script from "./AddPatent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddPatent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddPatent.vue?vue&type=style&index=0&id=8604dc6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports